import { openDB } from 'idb';

const DB_NAME = 'wahi-pos-offline';
const DB_VERSION = 1;

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('products')) {
      db.createObjectStore('products', { keyPath: 'id' });
    }
  },
});

export async function saveProductsOffline(products) {
  const db = await dbPromise;
  const tx = db.transaction('products', 'readwrite');
  await tx.store.clear();
  for (const p of products) {
    await tx.store.put(p);
  }
  await tx.done;
}

export async function getProductsOffline() {
  const db = await dbPromise;
  return db.getAll('products');
}